import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h3>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"understandingCredit") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"column small-12 medium-12 large-6\">\r\n    <h4 class=\"understanding-credit-cc-heading\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"heading") : depth0), depth0)) != null ? stack1 : "")
    + "</h4>\r\n    <p class=\"understanding-credit-cc-paragraph\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"intro") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"understandingCredit") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"understandingCredit") : stack1)) != null ? lookupProperty(stack1,"row1") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":2},"end":{"line":10,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n<div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"understandingCredit") : stack1)) != null ? lookupProperty(stack1,"row2") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":2},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/understanding-credit-cc-module",
  "version": "1.0.2",
  "id": "understandingCreditCcModule",
  "containerID": "creditCardsUnderstandingCreditCcModule",
  "moduleName": "credit-cards-understanding-credit-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "understanding-credit-cc-module",
  "data": {
    "options": {},
    "init": "CreditCardsUnderstandingCreditCcModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8"
  },
  "stores": []
};

class UnderstandingCreditCcModule extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: UnderstandingCreditCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { UnderstandingCreditCcModule as default, moduleConfig };
